import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FieldAgentClient, CampaignAction, Campaign } from 'ep-bt-field-agent-proxy';

@Component({
    selector: 'epbt-fa-campaign-action-list',
    templateUrl: './epbt-fa-campaign-action-list.component.html',
    styleUrls: ['./epbt-fa-campaign-action-list.component.scss']
})
export class EpbtFaCampaignActionListComponent implements OnInit {

    @Input() campaignActions: any[] = []

    // private _selectedCampaignAction: CampaignAction;
    // @Input('selectedCampaignAction') set selectedCampaignAction(value: CampaignAction) {
    //   this._selectedCampaignAction = value;
    //   this.campaignActionChange.emit(this._selectedCampaignAction);
    // }
    // get selectedCampaignAction(): CampaignAction {
    //   return this._selectedCampaignAction;
    // }

    private _selectedCampaignAction: number;
    @Input('selectedCampaignAction') set selectedCampaignAction(value: number) {
        this._selectedCampaignAction = value;
        if (this._selectedCampaignAction) {
            var result = this.campaignActions.filter(x => x.campaignActionsID == this._selectedCampaignAction);
            this.campaignActionChange.emit(result ? result[0] : null);
        }
    }
    get selectedCampaignAction(): number {
        return this._selectedCampaignAction;
    }

    // @Input() selectedCampaign: Campaign;

    @Output() campaignActionChange = new EventEmitter<any>();
    @Input() disabled: boolean = false;
    @Input() isEditable: boolean = true;
    @Input() labelText: string = "For";

    constructor(private client: FieldAgentClient) { }

    ngOnInit() {
        // this.GetCampaignActions();
    }

    ngAfterViewInit() {
        // this.GetCampaignActions();
    }

    onSelectionChange(selectedValue: any) {
        if (selectedValue) {
            // this.selectedCampaignAction = selectedValue;
            // this.campaignActionChange.emit(this.selectedCampaignAction);
            // console.log("EpbtFaCampaignActionListComponent - onSelectionChange - Start");
            this.selectedCampaignAction = selectedValue.campaignActionsID;
            var result = this.campaignActions.filter(x => x.campaignActionsID == this._selectedCampaignAction);
            this.campaignActionChange.emit(result ? result[0] : null);
            // console.log("EpbtFaCampaignActionListComponent - onSelectionChange - Start");
        }
    }

    async GetCampaignActions(campaignID: number) {
        this.client.getCampaignActions(campaignID).subscribe(res => {
            this.campaignActions = res;
            // console.log("EpbtFaCampaignActionListComponent - GetCampaignActions");
            // console.log(res);
        });
    }
}
